/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedNumber } from 'react-intl';
import TextArea from 'react-textarea-autosize';

import classNames from 'classnames';
import { _formatValue, _parseCurrency } from '../../../../utils/objectToFormData';

import BTW from '../../../../data/BTW';

import OfferRowModel from '../../../../stores/models/OfferRowModel';
import OfferModel from '../../../../stores/models/OfferModel';

import NumberInput from '../../../../components/ui/NumberInput/NumberInput';
import DropDown from '../../../../components/ui/DropDown/DropDown';
import { ApplicationContext } from '../../../../ApplicationContext';

/**
 *
 */
class OfferConceptRow extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = {};

		this.onRemove = this.onRemove.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onDragStart = this.onDragStart.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
		this.onDragStartBlock = (_e) => {
			this.blockDrag = true;
		};
		this.onDragStartRelease = (_e) => {
			this.blockDrag = false;
		};
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const classes = classNames({
			'offer-concept-row border border--bottom': true,
			'offer-concept-row--dragging': this.state.dragging
		});

		const { offerModel, offerRowModel } = this.props;

		return (
			<tr
				className={classes}
				draggable
				onDragStart={this.onDragStart}
				onDragEnd={this.onDragEnd}
				data-uid={offerRowModel._uid}>
				<td className="invoice-concept-row__column invoice-concept-row__dragicon">
					<div className="icon icon--left icon--drag-smoke" />
				</td>
				<td
					className="offer-concept-row__column offer-concept-row__description"
					onMouseDown={this.onDragStartBlock}
					onMouseUp={this.onDragStartRelease}
					onMouseLeave={this.onDragStartRelease}>
					<TextArea
						maxLength={4096}
						name="description"
						onChange={this.onInputChange}
						required
						value={offerRowModel.description}
					/>
				</td>
				<td
					className="offer-concept-row__column offer-concept-row__units"
					onMouseDown={this.onDragStartBlock}
					onMouseUp={this.onDragStartRelease}
					onMouseLeave={this.onDragStartRelease}>
					<NumberInput
						name="units"
						value={_formatValue(offerRowModel.units, true)}
						showIcon={false}
						onChange={this.onInputChange}
					/>
				</td>
				<td
					className="offer-concept-row__column offer-concept-row__unitprice"
					onMouseDown={this.onDragStartBlock}
					onMouseUp={this.onDragStartRelease}
					onMouseLeave={this.onDragStartRelease}>
					<NumberInput
						name="unitPrice"
						value={_formatValue(offerRowModel.unitPrice, true)}
						onChange={this.onInputChange}
					/>
				</td>
				<td className="offer-concept-row__column offer-concept-row__btw">
					<DropDown
						name="btw"
						className="col--12"
						value={offerRowModel.btw}
						onChange={this.onInputChange}>
						<option value={BTW.HOOG.name}>
							{this.props.intl.formatMessage({ id: BTW.HOOG.translationId() })}
						</option>
						<option value={BTW.LAAG.name}>
							{this.props.intl.formatMessage({ id: BTW.LAAG.translationId(offerModel.date) })}
						</option>
						<option value={BTW.VERLEGD.name}>
							{this.props.intl.formatMessage({ id: BTW.VERLEGD.translationId() })}
						</option>
						<option value={BTW.VRIJGESTELD.name}>
							{this.props.intl.formatMessage({ id: BTW.VRIJGESTELD.translationId() })}
						</option>
						<option value={BTW.GEEN.name}>
							{this.props.intl.formatMessage({ id: BTW.GEEN.translationId() })}
						</option>
					</DropDown>
				</td>
				<td className="offer-concept-row__column offer-concept-row__amount">
					<FormattedNumber
						style="currency"
						currency="EUR"
						value={offerRowModel.amount}
						minimumFractionDigits={2}
						maximumFractionDigits={2}
					/>
				</td>
				<td className="offer-concept-row__column table-row__column">
					<div className="table-row__actions icon icon--delete-black" onClick={this.onRemove} />
				</td>
			</tr>
		);
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		switch (e.target.name) {
			case 'units':
			case 'unitPrice':
				this.props.offerRowModel[e.target.name] = _parseCurrency(e.target.value);
				break;
			default:
				this.props.offerRowModel[e.target.name] = e.target.value;
		}

		this.props.offerRowModel.update(this.props.offerModel.date);
		this.onChange();
	}

	/**
	 *
	 * @param event
	 */
	onDragStart(event) {
		if (this.blockDrag) {
			event.preventDefault();
			event.stopImmediatePropagation();
			return;
		}

		this.draggingTimeout = setTimeout(() => {
			this.setState({ dragging: true });
		}, 50);

		this.props.onDragStart(this.props.offerRowModel, event);
	}

	/**
	 *
	 * @param event
	 */
	onDragEnd(_event) {
		clearTimeout(this.draggingTimeout);
		this.setState({ dragging: false });
		this.props.onDragEnd(this.props.offerRowModel);
	}

	/**
	 *
	 */
	onRemove() {
		if (this.props.onRemove) {
			this.props.onRemove(this.props.offerRowModel);
		}
	}

	/**
	 *
	 */
	onChange() {
		if (this.props.onChange) {
			this.props.onChange(this.props.offerRowModel);
		}
	}
}

OfferConceptRow.contextType = ApplicationContext;

OfferConceptRow.propTypes = {
	offerRowModel: PropTypes.instanceOf(OfferRowModel),
	offerModel: PropTypes.instanceOf(OfferModel).isRequired,
	intl: PropTypes.object,
	onChange: PropTypes.func,
	onRemove: PropTypes.func,
	onDragStart: PropTypes.func.isRequired,
	onDragEnd: PropTypes.func.isRequired
};

export default injectIntl(OfferConceptRow);
